enum AuditLogAction {
  SET = 'set',
  DELETE = 'delete',
  ARRAY_ADD = 'arrayAdd',
  ARRAY_REMOVE = 'arrayRemove',
}

export default AuditLogAction
